import "../styles/divider.css";

const Divider = () => {
    return (
        <hr className="rounded"></hr>
    )
}

export default Divider;